import {
  BooleanOperator,
  Operator,
  QueryBuilderQuery,
  QueryBuilderSubquery,
  SearchContext,
} from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';

export const advancedSearchComponentNameAndTypeAndStartSetQuery = (
  componentName: string,
  componentTypeName: string,
  startSetFilter: QueryBuilderSubquery | null
): QueryBuilderQuery => {
  const componentRules = [
    componentName
      ? {
          id: 'name',
          field: 'name',
          input: 'text',
          type: 'string',
          operator: Operator.CONTAINS_SUBSTRING,
          value: componentName,
        }
      : null,
    componentTypeName
      ? {
          id: 'typeName',
          field: 'typeName',
          input: 'text',
          type: 'string',
          operator: Operator.EQUAL,
          value: componentTypeName,
        }
      : null,
    startSetFilter ? startSetFilter : null,
  ];

  return {
    condition: BooleanOperator.AND,
    rules: [
      {
        id: 'type',
        field: 'type',
        type: 'string',
        input: 'select',
        operator: Operator.EQUAL,
        value: SearchContext.COMPONENT,
      },
      {
        condition: BooleanOperator.AND,
        rules: componentRules.filter(isTruthy),
      },
    ],
  };
};
